import React from "react";
import { Outlet } from "react-router";

const AnonLayout = () => {
  return (
    <div className="anon-layout">
      <main role="main" className="container-fluid">
        <Outlet />
      </main>
    </div>
  );
};

export default AnonLayout;
